module.exports = __webpack_public_path__ + "static/media/cat_zon.7ce2ff6f.png";